/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.14.1
 */

import { IWizardBillsDocTranslation } from '../../types';
import { initWizardPropsTranslation } from './initWizardTranslation';

export const initWizardBillsDocTranslation: IWizardBillsDocTranslation = {
    ...initWizardPropsTranslation,
    chooseDoc: {
        actOrder: '',
        format: '',
        invoice: '',
        invoiceAdvanced: '',
        invoiceOrder: '',
        orderWithDetailStatus: {
            disable: '',
            partially: '',
        },
        report: '',
        reportWithDetail: '',
        reportWithoutDetail: '',
        title: '',
    },

    reports: {
        compressionPassword: '',
        destEmailForLink: '',
        needCompression: '',
    },
    sendDocumentTitle: '',
    summaryParams: {
        documents: '',
    },

    summaryModal: {
        formedFailure: {
            acts: '',
            bills: '',
            fucts: '',
            invoices: '',
        },
        formedSuccess: {
            acts: '',
            bills: '',
            fucts: '',
            invoices: '',
            title: '',
        },
        title: '',
    },
}
